import React from "react";
import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { CapabilityUsage } from "@models/adminMonitoring";
import { AdminTable, col } from "@components/AdminTable";
import { formatCount } from "@utils/monitoringFormat";

/** Cost and units of one transaction per capability (and currency). */
const CapabilityTable: React.FC<{ rows: CapabilityUsage[] }> = ({ rows }) => {
  const { t } = useTranslation();
  const columns = [
    col.badge<CapabilityUsage>("capability", t("admin.insights.columns.capability"),
      (r) => <Badge size="sm" variant="light">{r.capability || "-"}</Badge>),
    col.number<CapabilityUsage>("events", t("admin.insights.columns.events"), (r) => r.event_count),
    col.text<CapabilityUsage>("tokens", t("admin.insights.columns.tokens"),
      (r) => (r.total_tokens == null ? "-" : `${formatCount(r.input_tokens)} / ${formatCount(r.output_tokens)}`)),
    col.number<CapabilityUsage>("pages", t("admin.insights.columns.pages"), (r) => r.pages_processed),
    col.money<CapabilityUsage>("cost", t("admin.insights.columns.cost"), (r) => ({
      amount: r.total_cost, currency: r.currency, warn: r.unpriced_count > 0,
      note: r.unpriced_count > 0 ? t("admin.insights.unpricedBadge", { count: r.unpriced_count }) : undefined,
    })),
  ];
  return <AdminTable columns={columns} data={rows} getRowKey={(r) => `${r.capability}-${r.currency}`} />;
};

export default CapabilityTable;
